import Api from './Api'

class ReportService {
    generateCsv = async (payload) => {
        return await Api().post('analytics-file', payload)
    }

    getCsvRows = async (params) => {
        return await Api().get(`analytics-file`, {
            params: params
        })
    }
    getCsvFile = async (csvId) => {
        return await Api().get(`analytics-csv-download`, {params: {csvId}})
    }
}

export default new ReportService()
